import { render, staticRenderFns } from "./CampaignsAdGroupsGrid.vue?vue&type=template&id=395f9bb4&scoped=true"
import script from "./CampaignsAdGroupsGrid.vue?vue&type=script&lang=ts"
export * from "./CampaignsAdGroupsGrid.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsAdGroupsGrid.vue?vue&type=style&index=0&id=395f9bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f9bb4",
  null
  
)

export default component.exports